module.exports = __webpack_public_path__ + "static/media/compare-01.33761cbe.jpg";